<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      background-color="#fff"
      :is-full-page="true"
    >
    </loading>
    <h2 v-if="!loading">Detalle pago {{ userPayment.nombre }}</h2>
    <b-row  v-if="errors.length > 0">
      <b-col lg="12">
        <div v-for="(error_message, iErrorMsg) in errors" v-bind:key="iErrorMsg">
          <CAlert color="danger" closeButton>{{ error_message }}</CAlert>
        </div>
      </b-col>
    </b-row>
    <section v-if="!loading">
      <b-row>
        <b-modal
          title="Resultado de operación"
          v-model="showAlertModal"
          no-close-on-backdrop
          hide-header-close
          size="md"
        >
          <b-row>
            <b-col>
              <div v-for="msg in alertMsgs" v-bind:key="msg">
                {{msg}}
              </div>
            </b-col>
          </b-row>
          <template #modal-footer>
            <div class="w-100">
              <b-row>           
                <b-col lg="6">
                  <b-button 
                    size="md" 
                    variant="warning" 
                    @click="goTo('walker-payments')"
                    >
                    Aceptar
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </template>
        </b-modal>
      </b-row>
      <b-row>
        <b-col lg="6">
          <CCard>
            <CCardHeader>
              <strong>Resumen</strong>
            </CCardHeader>
            <CCardBody>
              <CRow>

                <CCol sm="12" lg="12">
                  <CRow>
                    <CCol sm="12" lg="12" v-if="providerBanckAccount">
                      <CRow>
                        <CCol sm="12" lg="6">
                          <b-form-group>
                            <label><strong>Cuenta</strong></label>
                            <b-form-input :value="providerBanckAccount.bank" disabled></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol sm="12" lg="6">
                          <b-form-group>
                            <label><strong># Cuenta</strong></label>
                            <b-input-group size="sm">
                              <b-form-input :value="providerBanckAccount.number" size="sm" disabled></b-form-input>
                              <b-input-group-append>
                                <b-button variant="secondary" size="sm" @click="copyAccountNumber">
                                  <CIcon name="cil-copy" width="16"/>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol sm="12" lg="12">
                      <b-form-group>
                        <strong>Comentarios *</strong>
                        <b-form-textarea
                          v-model="comments"
                          rows="5"
                          placeholder="Ingrese sus comentarios aquí"
                        ></b-form-textarea>
                      </b-form-group>
                    </CCol>
                    <hr class="mt-0">
                    <CCol sm="6" lg="6">
                      <b-form-group>
                        <strong>Subtotal ganancias *</strong>
                        <b-form-input
                          id="quantity"
                          type="number"
                          min="1"
                          placeholder=""
                          disabled
                          v-model="subtotal"
                        >
                        </b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol sm="6" lg="6">
                      <b-form-group>
                        <strong>Descuentos *</strong>
                        <b-form-input
                          id="fineDiscounts"
                          type="number"
                          placeholder=""
                          v-model="fineDiscounts"
                        >
                        </b-form-input>
                      </b-form-group>
                    </CCol>
                    <hr class="mt-0">
                    <CCol lg="9" style="text-align: right;">
                      <h4>Total a pagar</h4>
                    </CCol>
                    <CCol lg="3" style="text-align: right;">
                      <h4>{{ total |thousand}}</h4>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <br>
              <b-row>
                <b-col lg="4" offset-lg="8">
                  <b-button 
                    variant="warning"
                    block 
                    :disabled="!canSubmit"
                    @click="submit">Pagar
                  </b-button>
                </b-col>
              </b-row>
            </CCardBody>
          </CCard>  
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12">
            <CCard>
              <CCardHeader>
                
                <div class="card-header-actions">
                  <b-button-group>
                    <b-button
                      v-for="option in statusOptions.filter(opt => opt.value === 35)"
                      :key="option.value"
                      size="sm"
                      :disabled="!hasSelectedItems"
                      @click="changeSelectedStatus(option.value)"
                      :style="{ backgroundColor: option.color, borderColor: option.color, color: 'white' }"
                    >
                      {{ option.label }}
                    </b-button>
                  </b-button-group>
                  <b-button 
                    @click="exportToExcel"
                    class="ml-2"
                  >Exporta excel</b-button>
                </div>

                <section>
                  <!-- User Interface controls -->
                  <b-row>
                    <b-col lg="6" class="my-1">
                      <b-form-group
                        label="Ordenar por"
                        label-for="sort-by-select"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                      >
                        <b-input-group size="sm">
                          <b-form-select
                            id="sort-by-select"
                            v-model="sortBy"
                            :options="sortOptions"
                            :aria-describedby="ariaDescribedby"
                            class="w-75"
                          >
                            <template #first>
                              <option value="">-- none --</option>
                            </template>
                          </b-form-select>

                          <b-form-select
                            v-model="sortDesc"
                            :disabled="!sortBy"
                            :aria-describedby="ariaDescribedby"
                            size="sm"
                            class="w-25"
                          >
                            <option :value="false">Asc</option>
                            <option :value="true">Desc</option>
                          </b-form-select>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col lg="6" class="my-1">
                      <b-form-group
                        label="Orden inicial"
                        label-for="initial-sort-select"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                      >
                        <b-form-select
                          id="initial-sort-select"
                          v-model="sortDirection"
                          :options="['asc', 'desc', 'last']"
                          size="sm"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col lg="6" class="my-1">
                      <b-form-group
                        label="Filtro"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            id="filter-input"
                            v-model="filterText"
                            type="search"
                            placeholder="Escribe para buscar"
                            @keyup.enter="setFilterText"
                          ></b-form-input>

                          <b-input-group-append>
                            <b-button :disabled="!filterText" @click="setFilterText">Buscar</b-button>
                          </b-input-group-append>

                          <b-input-group-append>
                            <b-button :disabled="!filterText" @click="cleantFilterText">Limpiar</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col lg="6" class="my-1">
                      <b-form-group
                        v-model="sortDirection"
                        label="Filtrar por"
                        description="Deja todo sin seleccionar para filtrar por todos los datos"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                      >
                        <b-form-checkbox-group
                          v-model="filterOn"
                          :aria-describedby="ariaDescribedby"
                          class="mt-1"
                        >
                          <b-form-checkbox value="cliente">Cliente</b-form-checkbox>
                          <b-form-checkbox value="mascota">Mascota</b-form-checkbox>              
                        </b-form-checkbox-group>
                      </b-form-group>
                    </b-col>

                    <b-col sm="5" md="6" class="my-1">
                      <b-form-group
                        label="Per page"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                      >
                        <b-form-select
                          id="per-page-select"
                          v-model="perPage"
                          :options="pageOptions"
                          size="sm"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="7" md="6" class="my-1">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </section>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <CCol sm="12" lg="12" v-if="items.length > 0">
                    <b-table
                      :items="items"
                      :fields="fields"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      :selectable="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      stacked="md"
                      show-empty
                      small
                      select-mode="multi"
                      @selection-changed="onSelectionChanged"
                    >
                      <template #head(selected)>
                        <b-form-checkbox
                          :checked="isAllSelected"
                          :indeterminate="isIndeterminate"
                          @change="toggleSelectAll"
                        ></b-form-checkbox>
                      </template>

                      <template #cell(selected)="data">
                        <b-form-checkbox
                          :checked="data.item.selected"
                          @change="toggleItemSelection(data.index)"
                        ></b-form-checkbox>
                      </template>

                      <template #cell(nueva_ganancia)="data">
                        <b-form-input
                          type="number"
                          :value="data.item.nueva_ganancia"
                          @input="(value) => updateNuevaGanancia(data.index, value)"
                        ></b-form-input>
                      </template>

                      <template #cell(estado)="data">
                        <b-form-select
                          v-model="data.item.estado"
                          :options="statusOptions"
                          value-field="value"
                          text-field="label"
                          :style="{ backgroundColor: getStatusColor(data.item.estado) }"
                          class="status-select"
                          :disabled="data.item.estado === 3"
                          @change="updateEstado(data.index, $event)"
                        ></b-form-select>
                        <b-button
                          size="sm"
                          @click="data.toggleDetails">
                          {{ data.detailsShowing ? 'Ocultar' : 'Ver' }} Detalle
                        </b-button>
                      </template>

                      <template #row-details="row">
                       <b-card>
                         <b-row>                    
                             <b-col lg="12" md="12">
                                 <div class="mt-3" v-if="row.item.estado === 34">
                                     <strong>Comentarios de paseador:</strong>
                                     <b-form-input
                                       type="text"
                                       :value="row.item.comentario_prov || ''"
                                       placeholder="Ingrese comentarios aquí"
                                       disabled
                                     ></b-form-input>
                                 </div>
                             </b-col>
                         </b-row>
                       </b-card>
                      </template> 
                    </b-table>
                  </CCol>

              </CRow>
              <CRow>
                <div>
                  <strong>Total servicios: {{ items.length }}</strong>
                </div>
                
              </CRow>
            </CCardBody>
          </CCard>  
        </b-col>
      </b-row>

    </section>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import moment from "moment";
import Loading from "vue-loading-overlay";

export default {
  name: 'WalkerPaymentDetail',
  components: {
    Loading
  },
  data() {
    return {
      loading: true,
      alertMsgs: [],
      showAlertModal: false,
      errors: [],
      userPayment: null,
      fineDiscounts: 0,
      comments: '',
      items: [],
      fields: [],
      currentPage: 1,
      perPage: 50,
      sortBy: '',
      sortDesc: true,
      statusOptions: [
        { value: 1, color: "#6A9D50", label: "Aprobado" },
        { value: 2, color: "#D65E81", label: "Rechazado" },
        { value: 3, color: "#D7CE55", label: "En análisis" },
        { value: 34, color: "#0089FF", label: "Comentarios" },
        { value: 35, color: "#51B685", label: "Aceptado" }
      ],
      totalRows: 1,
      pageOptions: [50, 100, { value: 100, text: "Show a lot" }],
      sortDirection: "asc",
      filter: null,
      filterText: null,
      filterOn: [],
      selectedItems: [],
      providerBanckAccount: null
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    subtotal() {
      return this.items.reduce((acc, item) => {
        // Solo sumar si el estado es 1 (Aprobado)
        if (item.estado === 35) {
          // Si nueva_ganancia > 0, usarla, si no, usar ganancia
          const valor = (item.nueva_ganancia && item.nueva_ganancia > 0)
            ? Number(item.nueva_ganancia)
            : Number(item.ganancia) || 0;
          return acc + valor;
        }
        return acc;
      }, 0);
    },
    total() {
      return this.subtotal - this.fineDiscounts
    },
    canSubmit() {
      return !this.items.some(item => item.estado !== 35);
    },
    isAllSelected() {
      return this.items.length > 0 && this.items.every(item => item.selected);
    },
    isIndeterminate() {
      const selectedCount = this.items.filter(item => item.selected).length;
      return selectedCount > 0 && selectedCount < this.items.length;
    },
    hasSelectedItems() {
      return this.items.some(item => item.selected);
    }
  },
  created() {
    this.loadData()
    this.watch()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.userPayment = null
      this.userPayment = this.$store.getters.walkerPayDetail
      this.items = this.userPayment.servicios.items

      console.log('userPayment', this.userPayment)
      const providerUsername = this.userPayment.usuario
      await this.getProviderProfile(providerUsername)
      
      // Agregar campo selected al inicio de fields
      this.fields = [
        { key: 'selected', label: '', sortable: false },
        ...this.userPayment.servicios.fields
      ];
      
      // Inicializar la propiedad selected en cada item
      this.items = this.items.map(item => ({
        ...item,
        selected: false
      }));
      
      this.loading = false
    },
    async getProviderProfile(providerUsername) {
      try {
      const getProviderProfile = this.$firebase.functions().httpsCallable('getProviderByUserAppLogin');
        const {data: providerProfile} = await getProviderProfile({username:providerUsername})
        console.log('providerProfile', providerProfile)
          const raw = providerProfile.cuenta_banco
          try {
            this.providerBanckAccount = typeof raw === 'string' ? JSON.parse(raw) : raw
          } catch (e) {
            this.providerBanckAccount = null
          }
        return providerProfile
      } catch (error) {
        console.log('error', error)
        return null
      }
    },
    async copyAccountNumber() {
      try {
        const value = this.providerBanckAccount && this.providerBanckAccount.number ? String(this.providerBanckAccount.number) : ''
        if (!value) return
        await navigator.clipboard.writeText(value)
        // Feedback simple
        this.$bvToast && this.$bvToast.toast('Número de cuenta copiado', { title: 'Copiado', autoHideDelay: 1500 })
      } catch (e) {
        // fallback simple
        window.alert('Copiado al portapapeles')
      }
    },
    watch() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "defWalkerPayDetail") {
          this.userPayment = this.$store.getters.walkerPayDetail
          this.items = this.userPayment.servicios.items
          this.fields = this.userPayment.servicios.fields
        }
      })
    },
    exportToExcel() {
      // Preparar los datos para exportar, reemplazando el valor del estado por su label
      const itemsToExport = this.items.map(item => {
        const statusOption = this.statusOptions.find(opt => opt.value === item.estado);
        return {
          ...item,
          estado: statusOption ? statusOption.label : 'Desconocido'
        };
      });

      // Convertir los datos de la tabla a formato de hoja de cálculo
      const ws = XLSX.utils.json_to_sheet(itemsToExport);

      // Ajustar el ancho de las columnas
      const wscols = this.fields.map(() => ({ wch: 10 })); // Ancho uniforme para todas las columnas
      ws['!cols'] = wscols;

      // Crear un nuevo libro de trabajo
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Pagos');

      // Generar el archivo y descargarlo
      const joinName = this.userPayment.nombre.split(' ').join('_');
      const fileName = `pagos_${joinName}_${moment().format('YYYY-MMM')}.xlsx`;
      XLSX.writeFile(wb, fileName);
    },
    updateSubtotal() {
      // Forzar la actualización del computed property
      this.$forceUpdate();
    },
    updateNuevaGanancia(index, value) {
      this.$set(this.items, index, {
        ...this.items[index],
        nueva_ganancia: Number(value),
        // estado: 3 // Set estado to "En análisis" (value 3) when nueva_ganancia changes
      });
    },
    updateEstado(index, value) {
      this.$set(this.items, index, {
        ...this.items[index],
        estado: Number(value)
      });
      // Forzar actualización del computed
      this.$forceUpdate();
    },
    getStatusColor(status) {
      const option = this.statusOptions.find(opt => opt.value === status);
      return option ? option.color : this.statusOptions[2].color; // Default to "En análisis" color
    },
    submit() {
      const payload = {
        userId: this.userPayment.id,
        comments: this.comments,
        subtotal: this.subtotal,
        fineDiscounts: this.fineDiscounts,
        total: this.total,
        items: this.items,
      }

      console.log('payload', payload);
      this.alertMsgs = [];
      this.loading = true;
      const fetchCreateWalkerPayment = this.$firebase.functions().httpsCallable('createWalkerPaymentV2');

      fetchCreateWalkerPayment(payload).then(response => {
        console.log('response', response);
        this.alertMsgs.push('Pago a ' + this.userPayment.nombre + ' registrado exitosamente!')
        this.showAlertModal = true;
      }).catch(error => {
        this.errors.push(error);
      }).finally(()=> this.loading = false)
    },
    goTo(to) {
      if(to == 'walker-payments') {
        this.$router.replace({ name: 'walker-payment-calculator' })
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setFilterText(){
      this.filter = this.filterText
    },
    cleantFilterText(){
      this.filter = null
      this.filterText = null
    },
    toggleSelectAll() {
      const newValue = !this.isAllSelected;
      this.items.forEach(item => {
        this.$set(item, 'selected', newValue);
      });
    },
    toggleItemSelection(index) {
      this.$set(this.items[index], 'selected', !this.items[index].selected);
    },
    onSelectionChanged(selectedItems) {
      this.selectedItems = selectedItems;
    },
    changeSelectedStatus(newStatus) {
      // Cambiar el estado de todos los items seleccionados
      this.items.forEach((item, index) => {
        if (item.selected && item.estado !== 3) {
          this.updateEstado(index, newStatus);
        }
      });
      
      // Deseleccionar todos después de cambiar el estado
      this.items.forEach(item => {
        this.$set(item, 'selected', false);
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.status-select {
  color: #333;
  font-weight: 500;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  min-width: 120px;
  
  &:focus {
    box-shadow: none;
    border-color: #ccc;
  }
  
  option {
    background-color: white;
    color: #333;
  }
}
</style>